import { setClientProfileId, setRecruiterCompanyId } from '@/config/axios';
import { IS_ADMIN_KEY } from '@/constants/roles';
import { DASHBOARD } from '@/constants/routes';
import {
  ADMIN_TOKEN_KEY,
  getLocalStorageItem,
  removeAdminUserId,
  removeLocalStorageItem,
  storeAccessToken,
} from '@/utils/localStorage';

export function isAdminImpersonating(): boolean {
  return (
    getLocalStorageItem(IS_ADMIN_KEY) === 'true' &&
    Boolean(getLocalStorageItem(ADMIN_TOKEN_KEY))
  );
}

/**
 * Restore the saved admin API token and clear impersonation profile headers.
 *
 * Intentionally keeps localStorage `isAdmin` until the subsequent hard navigation
 * rehydrates `/rest-auth/user/` as the real admin. Clearing that marker before
 * reload lets PrivateRoute treat the still-client Redux user as a forbidden
 * main-app client login and logoutUser() deletes the restored admin token.
 *
 * Also clears `recruiter_company_id` so a sticky agency workspace header cannot
 * follow the admin session after "login as" an agency user.
 */
export function prepareReturnToAdminSession(): void {
  const adminToken = getLocalStorageItem(ADMIN_TOKEN_KEY) || '';
  storeAccessToken(adminToken);
  removeLocalStorageItem(ADMIN_TOKEN_KEY);
  removeAdminUserId();
  setClientProfileId(null);
  setRecruiterCompanyId(null);
}

/** Full page load so Redux cannot keep a stale impersonated client mid-switch. */
export function hardNavigateToDashboard(): void {
  window.location.assign(DASHBOARD);
}
